module.exports = __webpack_public_path__ + "f87f2418410d554cd3a49dc75fdb7a20.webp";